export default {
    PENDING: "PENDING",
    ACTIVE: "ACTIVE",
    DECLINED: "DECLINED",
    REMOVED_BY_TM: "REMOVED_BY_TM",
    REMOVED_BY_INFLUENCER: "REMOVED_BY_INFLUENCER"
}
